import './ProductExtraOrderBlock.less';
import React, {useState, useEffect} from 'react';


export default function ProductExtraOrderBlock({
    buttonText,
    productExtra,
    images,
    cartHandler
}) {

    const addToCart = () => {
        cartHandler.addProductExtraToCart(
            productExtra,
            images.find(t => t.id === productExtra.avatar_image_id)
        );

        cartHandler.showPopup();
        cartHandler.renderCart();
    };

    return <div className="product-extra-order-block">
        <button
            type="button"
            className="order-button"
            onClick={() => addToCart()}
        >
            {buttonText}
        </button>
    </div>;
}
